<div class="row mb-3">
    <div class="col-sm-12">
        <button type="button" (click)="onContinueClick()" class="btn btn-primary me-2 float-end" *ngIf="!readOnly">
            <i class="fas fa-arrow-right"></i> Continue
        </button>
        <button type="button" (click)="onSaveClick(formGroup)" class="btn btn-secondary me-2 float-end"
            *ngIf="!readOnly && (permissions?.canSave ?? false)">
            <i class="fas fa-save"></i> Save
        </button>
        <button type="button" (click)="onFeedbackClick()" class="btn btn-secondary me-2 float-end"
            *ngIf="!readOnly && (permissions?.canNudge?? false)">
            <i class="far fa-message"></i> Notify of Comment
        </button>
    </div>
</div>

<div class="row" [formGroup]="formGroup">
    <div class="col-sm-12">
        <div class="card primary">
            <div class="card-header text-white bg-primary">
                Goal
            </div>
            <div class="card-body m-3">
                <div class="form-group mb-3">
                    <label class="form-label" for="goal">Goal Statement
                        <span class="required">*</span>
                    </label>
                    <div class="mb-2" style="font-size: .9em;">Explain your professional goals.</div>
                    <textarea name="goal" formControlName="goal" [rows]="8" class="form-control mb-3" required
                        [readOnly]="readOnly || !permissions?.canSubmit" (input)="onActionPlanChanged()"></textarea>
                </div>
                <div *ngIf="permissions?.canSave" class="text-center">
                    <span *ngIf="!formGroup?.valid || !actionPlanSaved" class="text-secondary">Unsaved</span>
                    <span *ngIf="formGroup?.valid && actionPlanSaved" class="text-success">Saved</span>
                </div>
            </div>
        </div>
    </div>
</div>